import { createSlice } from "@reduxjs/toolkit";

const getInitialLanguage = () => {
    if (typeof window !== "undefined") {
        const saved = localStorage.getItem("user_selected_language");
        if (saved) return Number(saved);
    }
    return 2; // Default to French
};

const initialState = {
    language: getInitialLanguage()
};

const languageSlice = createSlice({
    name: "languageSlice",
    initialState,
    reducers: {
        setLanguage: (state, action) => {
            const langId = Number(action.payload);
            state.language = langId;
            if (typeof window !== "undefined") {
                localStorage.setItem("user_selected_language", String(langId));
            }
            return state;
        },
    }
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice;